/* eslint-disable max-lines-per-function */
import { Button } from 'primereact/button'
import { Dropdown } from 'primereact/dropdown'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import UpsertPopup from '../../../components/form/UpsertPopup'
import Table from '../../../components/layout/Table'
import ImportModal from '../../../components/form/ImportModal'
import donViDangKyDuThiProcessor from '../../../processor/donViDangKyDuThiProcessor'

const DonViDangKyDuThi = (props) => {
  // const modeTitle = 'Đơn vị đăng ký dự thi'
  // const moduleName = 'đơn vị đăng ký dự thi'
  const modeTitle = 'Tên trường'
  const moduleName = 'tên trường'
  const processor = donViDangKyDuThiProcessor
  const { khoaThiId, listKhoaThi, namId, listNam } = props
  const [datas, setDatas] = useState([])
  const [selected, setSelected] = useState([])
  const [oneData, setOneData] = useState({})
  const [visible, setVisible] = useState(false)
  const toggle = () => setVisible(!visible)
  const toast = useSelector((store) => store.notify.toast)
  const confirm = useSelector((store) => store.notify.confirm)

  const getDonViDangKyDuThi = async () => {
    if (khoaThiId) {
      const rs = await processor.getByKhoaThi(khoaThiId)
      setDatas(rs)
    }
  }

  const onSubmit = async (data) => {
    const rs = await processor.import(
      data.map((item) => {
        return { code: item.Ma_DKThi, name: item.Ten_DKThi, khoaThiId }
      }),
      khoaThiId,
    )
    toast({ type: rs.isSuccess ? 'success' : 'error', message: rs.data })
    await getDonViDangKyDuThi()
  }

  useEffect(getDonViDangKyDuThi, [khoaThiId])

  const save = async (data) => {
    const rs = await processor.upsert(data)
    let message
    let newData
    if (rs.isSuccess) {
      if (data.id) {
        newData = datas.map((item) => {
          return item.id === oneData.id ? data : item
        })
        message = rs.data
      } else {
        newData = [{ ...data, id: rs.data }, ...datas]
        message = 'Thêm mới thành công'
      }
      setDatas(newData)
      toggle()
    }
    toast({ type: rs.isSuccess ? 'success' : 'error', message })
  }
  const deleteOnClick = async (id) => {
    const rs = await processor.delete(id)
    toast({ type: rs.isSuccess ? 'success' : 'error', message: rs.data })
    if (rs.isSuccess) {
      setDatas([...datas.filter((item) => item.id !== id)])
      setSelected([...selected.filter((item) => item.id !== id)])
    }
  }

  const deleteMany = async () => {
    const rs = await processor.deleteMany(selected)
    toast({ type: rs.isSuccess ? 'success' : 'error', message: rs.data })
    if (rs.isSuccess) setDatas([...datas.filter((item) => !selected.find((i) => i.id === item.id))])
  }

  const column = [
    { value: 'code', name: 'Mã', sortable: true, width: '50%' },
    { value: 'name', name: 'Tên', sortable: true, width: '50%' },
    {
      name: 'Chức năng',
      alignHeader: 'center',
      render: (data) => {
        return (
          <div className="flex justify-content-center">
            <Button
              icon="pi pi-pencil"
              className="p-button-rounded p-button-warning mr-2"
              onClick={() => {
                setOneData(data)
                toggle()
              }}
              tooltip="Sửa"
              tooltipOptions={{ position: 'top' }}
            />
            <Button
              icon="pi pi-trash"
              className="p-button-rounded p-button-danger mr-2"
              onClick={() => {
                confirm({
                  action: () => deleteOnClick(data.id),
                  body: `Bạn có muốn xoá ${moduleName} này?`,
                })
              }}
              tooltip="Xoá"
              tooltipOptions={{ position: 'top' }}
            />
          </div>
        )
      },
    },
  ]
  const header = !oneData.id ? `Thêm mới ${moduleName}` : `Chỉnh sửa ${moduleName}`

  return (
    <>
      <UpsertPopup
        width="60%"
        visible={visible}
        toggle={toggle}
        header={header}
        data={oneData}
        onSave={save}
        fields={['code', 'name']}
        maxLength={{ code: 20, name: 100 }}
        required={['code']}
        name={{
          code: 'Mã',
          name: 'Tên',
        }}
        disable={!oneData.id ? [] : ['code']}
      />
      <div className="flex flex-column">
        <div className="flex justify-content-between">
          <h4>{modeTitle}</h4>
          <div className="flex vanbang-seacher-cotainer">
            <ImportModal
              template="/excel/temp/DV.xlsx"
              onSubmit={onSubmit}
              colsTemp={['Ma_DKThi', 'Ten_DKThi']}
            >
              <div className="flex flex-column">
                <Dropdown
                  optionLabel="name"
                  optionValue="id"
                  options={listNam}
                  value={namId}
                  disabled
                  className="mb-3"
                />
                <Dropdown
                  optionLabel="name"
                  optionValue="id"
                  options={listKhoaThi}
                  value={khoaThiId}
                  disabled
                  className="mb-3"
                />
              </div>
            </ImportModal>
            <div>
              <Button
                type="button"
                icon="pi pi-plus-circle"
                className="p-button-success ml-2 mb-2"
                onClick={() => {
                  setOneData({ khoaThiId })
                  toggle()
                }}
                label="Thêm"
              />
            </div>
            <div>
              <Button
                type="button"
                icon="pi pi-trash"
                className="p-button-danger ml-2 mb-2"
                onClick={() => {
                  confirm({
                    action: () => deleteMany(),
                    body: `Bạn có muốn xoá ${moduleName} này?`,
                  })
                }}
                disabled={selected.length === 0}
                label="Xoá"
              />
            </div>
          </div>
        </div>
        <div className="card">
          <Table data={datas} column={column} selected={selected} setSelected={setSelected} />
        </div>
      </div>
    </>
  )
}

export default DonViDangKyDuThi
